// src/components/QRCodeGenerator.js
// Generates QR codes for stall ordering
// Uses qrserver.com API (free, no install needed)
// Vendor admin: stall QR
// Mall admin: table QRs are rendered inline in MallAdminPanel (MallTablesTab)

import React, { useState } from 'react';

const BASE_URL = process.env.REACT_APP_BASE_URL || window.location.origin;

export function QRImage({ url, size = 200, label }) {
  const qrUrl = `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&data=${encodeURIComponent(url)}&bgcolor=ffffff&color=0B1C3D&margin=2`;

  const download = () => {
    const link = document.createElement('a');
    link.href = qrUrl;
    link.download = `qr-${label?.replace(/\s+/g,'-').toLowerCase() || 'order'}.png`;
    link.click();
  };

  return (
    <div style={{ textAlign:'center' }}>
      <div style={{ background:'#fff', borderRadius:12, padding:12, display:'inline-block', marginBottom:8 }}>
        <img src={qrUrl} alt={`QR for ${label}`} width={size} height={size} style={{ display:'block' }} />
      </div>
      <div style={{ fontSize:12, color:'var(--text2)', marginBottom:8, fontFamily:'monospace', wordBreak:'break-all', maxWidth:240 }}>
        {url}
      </div>
      <div style={{ display:'flex', gap:8, justifyContent:'center' }}>
        <button className="btn btn-ghost btn-sm" onClick={download}>
          ⬇️ Download
        </button>
        <button className="btn btn-ghost btn-sm" onClick={() => navigator.clipboard.writeText(url).then(() => alert('Link copied!'))}>
          📋 Copy Link
        </button>
        <a href={url} target="_blank" rel="noopener noreferrer" className="btn btn-ghost btn-sm">
          🔗 Test
        </a>
      </div>
    </div>
  );
}

// ── Vendor stall QR ──────────────────────────────────────────
export function VendorQRGenerator({ vendor }) {
  const [showTableInput, setShowTableInput] = useState(false);
  const [tableNo,        setTableNo]        = useState('');

  if (!vendor?.slug) return (
    <div style={{ padding:'10px 14px', background:'#3d1a1a', borderRadius:8, fontSize:13, color:'var(--red)' }}>
      ⚠️ Your stall needs a URL slug before a QR code can be generated.
      Contact your admin to set one.
    </div>
  );

  const baseUrl   = `${BASE_URL}/order/vendor/${vendor.slug}`;
  const tableUrl  = tableNo ? `${baseUrl}?table=${encodeURIComponent(tableNo)}` : null;

  return (
    <div>
      <div style={{ marginBottom:24 }}>
        <div style={{ fontWeight:600, fontSize:14, marginBottom:4 }}>📱 Stall QR Code</div>
        <div style={{ fontSize:12, color:'var(--text2)', marginBottom:16 }}>
          Place this at your counter. Customers scan to browse your menu and order from their phone.
        </div>
        <QRImage url={baseUrl} label={vendor.name} size={200} />
      </div>

      <div style={{ borderTop:'1px solid var(--border)', paddingTop:20 }}>
        <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:12 }}>
          <div className={`toggle${showTableInput?' on':''}`}
            onClick={() => setShowTableInput(p => !p)}
            style={{ cursor:'pointer' }} />
          <span style={{ fontSize:13, color:'var(--text2)' }}>Generate QR for a specific table</span>
        </div>

        {showTableInput && (
          <div>
            <div style={{ display:'flex', gap:10, marginBottom:16 }}>
              <input type="text" value={tableNo}
                onChange={e => setTableNo(e.target.value)}
                placeholder="Table number e.g. 7, A3, VIP-1"
                style={{ flex:1 }} />
            </div>
            {tableUrl && (
              <div style={{ marginTop:12 }}>
                <div style={{ fontSize:12, color:'var(--text2)', marginBottom:12 }}>
                  QR for Table {tableNo} — customer's order will show this table number in your kitchen.
                </div>
                <QRImage url={tableUrl} label={`${vendor.name} Table ${tableNo}`} size={180} />
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default VendorQRGenerator;
